/**
 * Repository for template favorites functionality
 */
import { AbstractRepository } from '@/repositories/abstract-repository';

export interface ToggleFavoriteRequest {
    template_type: 'email' | 'text';
    template_id: number;
    is_favorite: boolean;
}

export interface TemplateFavoriteResponse {
    id: number;
    userId: number;
    templateType: 'email' | 'text';
    templateId: number;
    createdAt: string;
}

export class TemplateFavoritesRepository extends AbstractRepository<TemplateFavoriteResponse> {
    readonly endpoint = 'communications/templates/favorites';

    /**
     * Toggle a template's favorite status for the current user
     */
    public async toggleFavorite(request: ToggleFavoriteRequest): Promise<void> {
        await this.client.post(`${this.endpoint}/toggle`, request);
    }

    /**
     * Get templates with favorite status included
     * Note: This method doesn't fetch favorites directly, but rather the templates endpoint
     * should be called with ?simple=true to include is_favorite field
     */
    public async getTemplatesWithFavorites(type: 'emails' | 'texts', simple = true): Promise<any> {
        const params = simple ? { simple: 'true' } : {};
        const response = await this.client.get(`communications/templates/${type}`, { params });
        return response.data;
    }
}
